import { render } from "./SoundManagerEditorCmp.vue?vue&type=template&id=1479969a"
import script from "./SoundManagerEditorCmp.vue?vue&type=script&lang=js"
export * from "./SoundManagerEditorCmp.vue?vue&type=script&lang=js"

import "./SoundManagerEditorCmp.vue?vue&type=style&index=0&id=1479969a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__